import { Enums } from "@/helpers/enums";
import { Ajax, MethodType } from "@/helpers/web";
import { appData, C, J } from "@/helpers/global";

export const LessonTeacherService = {
    List(callback, wait) {
        Ajax.Api(MethodType.Get, Enums.SERVICE.LESSON_TEACHER, null, wait).then((data) => {
            callback(data);
        });
    },
    ListPreview(callback, wait) {
        Ajax.Api(MethodType.Get, `${Enums.SERVICE.LESSON_TEACHER}/preview`, null, wait).then((data) => {
            callback(data);
        });
    },
    /*ById(id, callback, wait) {
        Ajax.Api(MethodType.Get, Enums.SERVICE.LESSON_TEACHER + "/" + id, null, wait).then((data) => {
            callback(data);
        });
    },*/
};